export default __webpack_public_path__ + "img/2.7d99f26.svg";